import type { ScheduledPostPlatform, SchedulerPresets } from "@shared/schema";
import { GlobalPresets } from "./presets/GlobalPresets";
import { InstagramPresets } from "./presets/InstagramPresets";
import { ThreadsPresets } from "./presets/ThreadsPresets";
import { LinkedinPresets } from "./presets/LinkedinPresets";
import { TikTokPresets } from "./presets/TikTokPresets";
import { YoutubePresets } from "./presets/YoutubePresets";

export function PresetsPanel({
  presets,
  selectedPlatforms,
  threadsSelected,
  onChange,
  tiktokForUserId,
  tiktokIsPhoto = false,
  tiktokVideoUrl,
  tiktokOnBlockedChange,
}: {
  presets: SchedulerPresets;
  selectedPlatforms: ScheduledPostPlatform[];
  threadsSelected: boolean;
  onChange: (next: SchedulerPresets) => void;
  tiktokForUserId?: string;
  tiktokIsPhoto?: boolean;
  tiktokVideoUrl?: string;
  tiktokOnBlockedChange?: (blocked: boolean) => void;
}) {
  return (
    <div className="space-y-2">
      <GlobalPresets
        value={presets.global}
        onChange={(next) => onChange({ ...presets, global: next })}
      />
      {selectedPlatforms.includes("instagram") && (
        <InstagramPresets
          value={presets.instagram}
          onChange={(next) => onChange({ ...presets, instagram: next })}
        />
      )}
      {threadsSelected && (
        <ThreadsPresets
          value={presets.threads}
          onChange={(next) => onChange({ ...presets, threads: next })}
        />
      )}
      {selectedPlatforms.includes("linkedin") && (
        <LinkedinPresets
          value={presets.linkedin}
          onChange={(next) => onChange({ ...presets, linkedin: next })}
        />
      )}
      {selectedPlatforms.includes("tiktok") && (
        <TikTokPresets
          value={presets.tiktok}
          onChange={(next) => onChange({ ...presets, tiktok: next })}
          forUserId={tiktokForUserId}
          isPhoto={tiktokIsPhoto}
          videoUrl={tiktokVideoUrl}
          onBlockedChange={tiktokOnBlockedChange}
        />
      )}
      {selectedPlatforms.includes("youtube") && (
        <YoutubePresets
          value={presets.youtube}
          onChange={(next) => onChange({ ...presets, youtube: next })}
        />
      )}
    </div>
  );
}
